import React from 'react';
import { useSelector } from 'react-redux';



export const EtablissementsTableRow = ({etablissement, setSelectedEtablissement, numberOfUsers}) => {

    const currentUserEmail = useSelector(state => state.user?.user?.email);

    const dateParts = etablissement.creationDate.substring(0, 10).split('-');
    return(
        <div className="card p-2 mt-1">
            <div className="row gx-2 gy-1 align-items-center">
                <div className="col-12 col-md">
                    <div className="row gx-2 gy-1 align-items-center">
                        <div className="col-1 col-md">
                            <div className="h5 ls-1 my-auto text-truncate text-muted">{etablissement.siret}</div>
                        </div>
                        <div className="col order-first order-md-0">
                            <div className="h5 text-uppercase font-weight-bold ls-1 my-auto text-truncate">{etablissement.name}</div>
                        </div>
                        <div className="col-12 col-md">
                            <div className="h5 ls-1 my-auto text-truncate">{dateParts[2]}/{dateParts[1]}/{dateParts[0]}</div>
                        </div>
                        <div className="col-12 col-md">
                            <div className="h5 ls-1 my-auto text-truncate">{numberOfUsers}</div>
                        </div>
                        <div className="col col-lg-2 col-xl-1">
                            <div className="h5 ls-1 my-auto container-press ml-auto">{etablissement.isEnabled ? "Actif" : "Désactivé"}</div>
                        </div>
                    </div>
                </div>
                <div className="col-12 d-md-none">
                    <hr className="my-0" />
                </div>
                <div className="col-12 col-md-3 col-lg-auto ml-auto">
                    <div className="w-md-min"></div>
                    <div className="flex-row justify-content-md-end">
                        <button type="button" className="btn btn-icon btn-stage-danger shadow-none p-1 rounded-sm mr-auto mr-md-0" data-toggle="modal" data-target="#DeletePartnerEstablishment" onClick={(e) => setSelectedEtablissement(etablissement)}>
                            <i className="eva eva-trash-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Supprimer l'établissement" data-template='<div class="tooltip tooltip-white-danger" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <button type="button" className="btn btn-icon btn-stage-secondary shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#AddPartnerEstablishment" onClick={(e) => setSelectedEtablissement(etablissement)}>
                            <i className="eva eva-edit-2-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Modifier l'établissement" data-template='<div class="tooltip tooltip-white-secondary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                        <button type="button" className="btn btn-icon btn-stage-primary shadow-none p-1 rounded-sm ml-2" data-toggle="modal" data-target="#GeneratePartnerApiKey" onClick={() => setSelectedEtablissement(etablissement)}>
                            <i className="eva eva-hash-outline align-middle h4 lh-1 m-auto" data-toggle="tooltip" title="Générer une API Key" data-template='<div class="tooltip tooltip-white-primary" role="tooltip"><div class="arrow"></div><div class="tooltip-inner px-3 py-2"></div></div>'></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

}